import { useQuery } from "react-query";
import {
  GET_ORDER_DETAILS_REFETCH_INTERVAL,
  ORDER_MICRO_SERIVCE,
  ROUTE_HOME,
} from "../constants";
import { useAuthState } from "../context/UserAuthentication/context";
import axiosWithInterceptor from "../services/axiosWithInterceptor";
import { getUser } from "../helpers/helperMethods";

interface IQueryParams {
  orderId: number;
  isFetchingOrderHistory?: boolean;
}

const MAX_400_TRIES = 3;

const is400Error = (error: any) => error?.response?.status === 400;

const getOrderDetails = async ({
  orderId,
}: IQueryParams) => {
  const response = await axiosWithInterceptor.get(
    `${ORDER_MICRO_SERIVCE}/orders/${orderId}?details=payment,store,pickup,tracking,am_here`
  );
  return response?.data?.data
};

export default function useOrderDetails({ orderId, isFetchingOrderHistory }: IQueryParams) {
  const authInfo = getUser();
  return useQuery(["orderdetails", orderId], () =>
  getOrderDetails({ orderId }), {
      enabled:
        !isFetchingOrderHistory &&
        !!orderId &&
        !!authInfo.id &&
        !!authInfo.token,
      refetchInterval: Number(GET_ORDER_DETAILS_REFETCH_INTERVAL),
      retry: (failureCount, error) => {
        if (!is400Error(error)) return false;
        // failureCount is 0-based: < 2 means up to 3 total attempts
        return failureCount < MAX_400_TRIES - 1;
      },
      onError: (error: any) => {
        if (is400Error(error)) {
          window.location.assign(ROUTE_HOME);
        }
      },
    }
  );
}
